const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export default function getRandomString(size = 6) {
  return [...Array(size)]
    .map(() => characters.charAt(Math.floor(Math.random() * characters.length)))
    .join('');
}
